import * as React from "react";
import styled from "styled-components";
import SearchButton from "../button/search/search";
import DrawerItemsList from "./drawer-items-list";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faClose,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import { DefaultFontStack } from "../typography/typography";
import DrawerItem from "./drawer-item";

const DrawerButton = styled.button`
  all: unset;
  appearance: none;
  background-color: transparent;
  cursor: pointer;
  @media (min-width: 1265px) {
    display: none;
  }
`;

const Root = styled.div`
  ${DefaultFontStack}
  position: fixed;
  z-index: 20;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.day};
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  transition: transform ease-in-out 100ms;
`;

const GoBackButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  gap: 2px;
`;

const PrimaryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
`;

const SecondaryHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 10px 0px 10px;
  gap: 10px;
  background-color: ${({ theme }) => theme.colors.cloud};
  color: ${({ theme }) => theme.colors.awesome};
  font-weight: 600;
`;

const Button = styled.button`
  all: unset;
  appearance: none;
  background-color: transparent;
  cursor: pointer;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.silver};
`;

function Drawer(props) {
  const { items } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState(null);

  const toggle = () => {
    setIsOpen((open) => !open);
  };

  const clearActiveItem = () => {
    setActiveItem(null);
  };

  const onCloseHandler = () => {
    clearActiveItem();
    toggle();
  };

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      <DrawerButton onClick={toggle} aria-label="Drawer Button">
        <FontAwesomeIcon icon={faBars} style={{ height: 20, width: 20 }} />
      </DrawerButton>
      <Root data-component-name="drawer" open={isOpen}>
        <PrimaryHeader>
          <SearchButton />
          <Button onClick={onCloseHandler} aria-label="Close Button">
            <FontAwesomeIcon icon={faClose} style={{ height: 20, width: 20 }} />
          </Button>
        </PrimaryHeader>
        {activeItem !== null ? (
          <SecondaryHeader>
            <GoBackButton onClick={clearActiveItem}>
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{ height: 20, width: 20 }}
              />
              <span>Go Back</span>
            </GoBackButton>
            <Divider />
            <span>{activeItem.text}</span>
            <Divider />
          </SecondaryHeader>
        ) : null}
        {activeItem === null ? (
          <DrawerItemsList
            items={items}
            onActiveItemChange={setActiveItem}
            onClose={onCloseHandler}
          />
        ) : (
          <DrawerItem item={activeItem} onClose={onCloseHandler} />
        )}
      </Root>
    </>
  );
}

export default Drawer;
